export default {
    'bond-number': 'Número de bono',
    new: 'Nuevo',
    'cash-statement': 'Estado de caja',
    add: 'Añadir',
    'posted-journals-balance': 'Saldo de revistas publicadas',
    edit: 'Editar',
    'save-bond': 'Guardar bono',
    save: 'Guardar',
    bond: 'Bono',
    not: 'No',
    posted: 'Publicado',

    'delete-cash-entry': 'Eliminar asiento efectivo',
    'are-you-sure-you-want-delete-the-entry' : '¿Estas seguro de eliminar asiento contable? El asiento contable compuesto relacionado también se eliminará.',

    'add-bond': 'Añadir bono',
    'bond-date': 'Fecha de bono',
    create: 'Crear',
    cancel: 'Cancelar',
    warning: 'Alerta',
    'No-fund-has-been-set-for-the-financial-file-yet': '¡Cuenta de caja principal sin asignar! Por favor, vaya a la configuración para asignarla',
    sum: 'Total:',
    'total-imports': 'Ingresos totales',
    'total-exports': 'Gasto total',
    'difference': 'Deferencia:',

    'incoming-coins': 'Ingresos en moneda extranjera',
    'outcome-coins': 'Gasto en moneda extranjera',

    'currency-equivalent': 'Saldo en otra moneda',
    'select-currency-to-show-the-currency-equivalent': 'Eligir la moneda a cambiar',

    'make-sure-the-data-entered-is-correct': 'Verificar los datos ingresados',

    headers: {
        sequence: 'Serial',
        account: 'Cuenta',
        debit: 'Gastos',
        credit: 'Ganancia',
        note: 'Descripción',
        currency: 'Moneda',
        'currency-debit': 'Ingresos en moneda extranjera',
        'currency-credit': 'Gastos en moneda extranjera',
        price: 'Precio',
        'paper-document-no': 'Ref. Doc.',
        'date': 'Fecha',
    },

    'not-posted-bonds': 'Bonos no arrastrados',
    'all-bonds-are-posted': 'Todos los bonos están arrastrados',

    'context-menu': {
        'account-statement' : 'Estado de cuenta',
        'edit' : 'Editar',
        'delete' : 'Eliminar'
    },

    'revolving-balance': 'Saldo rotatorio:',

    footer: {
        total: 'Total',
        difference: 'diferencia',
        revolved: 'rotatorio'
    },
    "reverse-currency-price": "Invertir la dirección del cálculo del precio de la moneda",
    "export-payment-bond": "Exportar bono de pago",
    "export-repayment-bond": "Exportar bono de devolución",

}